/**
 * Main entry point for the Portal application.
 * This file initializes the React application and sets up the root component.
 * It also imports global styles and internationalization configuration.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/styles/global.css";
import "./i18n"; // Import i18n configuration

// Create and render the root React component
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
